var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14276 13.0288H3.22847C2.21858 13.0288 1.3999 12.2101 1.3999 11.2002V2.97164C1.3999 1.96175 2.21858 1.14307 3.22847 1.14307H11.457C12.4669 1.14307 13.2856 1.96175 13.2856 2.97164V11.2002C13.2856 12.2101 12.4669 13.0288 11.457 13.0288H10.5428M14.657 13.0288H14.1999C13.695 13.0288 13.2856 12.6194 13.2856 12.1145V4.34307C13.2856 3.83812 13.695 3.42878 14.1999 3.42878H16.5033C16.7811 3.42878 17.0438 3.55503 17.2173 3.77192L20.3995 7.74977C20.5292 7.91189 20.5999 8.11331 20.5999 8.32092V12.1145C20.5999 12.6194 20.1906 13.0288 19.6856 13.0288M9.62847 12.5716C9.62847 13.834 8.60512 14.8574 7.34276 14.8574C6.08039 14.8574 5.05704 13.834 5.05704 12.5716C5.05704 11.3093 6.08039 10.2859 7.34276 10.2859C8.60512 10.2859 9.62847 11.3093 9.62847 12.5716ZM19.2285 12.5716C19.2285 13.834 18.2051 14.8574 16.9428 14.8574C15.6804 14.8574 14.657 13.834 14.657 12.5716C14.657 11.3093 15.6804 10.2859 16.9428 10.2859C18.2051 10.2859 19.2285 11.3093 19.2285 12.5716Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.016f93b08c658759b052fbe4283d16b3.svg";
export { ForwardRef as ReactComponent };